/*
 * @Description: 代办供应商-园区管理
 * @Date: 2026-03-30 16:06:33
 */
import { route } from './src/router';

const name = 'park-mgmt';
export { name, route };
